import React, { useState } from "react";

/* The task's public id, as agents and GitHub see it: ERP-<pk, 4-digit pad>.
   It must match the agent API's TaskResponseSerializer (McpAccessLayer
   serializers.py: f"ERP-{obj.id:04d}") exactly — SYNAPSE binds a pull
   request to a task by finding this string in the branch name or PR title,
   and closes the task when the PR merges.

   Clicking copies the id so it can be pasted into a branch name
   (feat/ERP-1062-short-name) or a PR title ([ERP-1062] …). */
export function erpTaskId(id) {
  const n = Number.parseInt(id, 10);
  return Number.isFinite(n) && n > 0 ? `ERP-${String(n).padStart(4, "0")}` : "";
}

const chipStyle = {
  display: "inline-block",
  marginRight: 8,
  padding: "1px 6px",
  borderRadius: 6,
  border: "1px solid var(--c-200, #e2e8f0)",
  background: "var(--c-50, #f8fafc)",
  color: "var(--c-600, #475569)",
  font: "600 11px/16px ui-monospace, SFMono-Regular, Menlo, monospace",
  letterSpacing: "0.02em",
  verticalAlign: "1px",
  cursor: "pointer",
  textDecoration: "none",
};

export function TaskIdChip({ id }) {
  const [copied, setCopied] = useState(false);
  const value = erpTaskId(id);
  if (!value) return null;

  const copy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      window.prompt("Copy this task id:", value);
      return;
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1200);
  };

  return (
    <button
      type="button"
      style={copied ? { ...chipStyle, color: "var(--green-700, #15803d)" } : chipStyle}
      onClick={copy}
      title="Copy the task id — put it in your branch name or PR title so the PR is linked to this task"
      aria-label={`Copy task id ${value}`}
    >
      {copied ? "Copied" : value}
    </button>
  );
}
